import { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import checkAuth from "./CheckAuth"
import LoadingComponent from "./LoadingComponent"

const AuthenticateRoute = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    const prefix = params?.prefix ?? ''
    const publicPaths = [
      `/${prefix}`,
      `/${prefix}/register`,
      `/${prefix}/login-user`,
      `/${prefix}/login-user/send-mail`,
      `/${prefix}/login-user/send-mail/success`,
      `/${prefix}/login-user/verify-success`,
      '/login-user/term-and-condition',
    ]

    if (publicPaths.includes(location.pathname)) {
      setIsReady(true)
      return
    }

    const account = localStorage.getItem('account')
    if (!account) {
      localStorage.removeItem('account')
      navigate(prefix ? `/${prefix}/login-user` : '/', { replace: true })
      return
    }

    const verifySession = async () => {
      const authenticated = await checkAuth(navigate, prefix)
      setIsReady(authenticated)
    }

    verifySession()
  }, [location.pathname, navigate, params?.prefix])

  if (!isReady) {
    return <LoadingComponent />
  }

  return <>{children}</>
}

export default AuthenticateRoute